import LogRocket from 'logrocket';
import getConfig from 'next/config';

export const recordUserSession = (userId: string) => {
  const {
    publicRuntimeConfig: { logrocketAppId },
  } = getConfig();
  if (userId && logrocketAppId) {
    // We only want a sample of all user sessions.
    // The easiest way is to always pick the same subset of users.
    // Otherwise we would need to keep track which sessions are tracked.
    // Let's always pick users with ids divisible by 10
    const shouldTrackUser = parseInt(userId, 10) % 10 === 0;
    if (shouldTrackUser) {
      LogRocket.init(logrocketAppId, {
        console: {
          shouldAggregateConsoleErrors: true,
        },
        rootHostname: 'italist.com',
      });
      LogRocket.identify(userId);
    }
  }
};
